import { StandardTabs } from '@cimplico/components';
import { useState } from 'react';
import { WorksheetReviewCondition } from '../../../../types/worksheet';
import { ClipboardDocumentCheckIcon } from '@heroicons/react/24/outline';
import EmptyStateNew from '../../../../components/empty-state/EmptyStateNew';
import ReviewCondition from './ReviewCondition';

type ReviewConditionsListProps = {
    conditions: WorksheetReviewCondition[];
};

function ReviewConditionsList({ conditions }: ReviewConditionsListProps): JSX.Element {
    const [satisfied, setSatisfied] = useState(false);

    const filteredConditions = conditions.filter((c) => c.satisfied === satisfied);

    return (
        <div className="overflow-auto flex flex-col gap-4 h-full">
            <StandardTabs
                tabs={[
                    { label: `Outstanding (${conditions.filter((c) => !c.satisfied).length})` },
                    { label: `Satisfied (${conditions.filter((c) => c.satisfied).length})` },
                ]}
                defaultIndex={satisfied ? 1 : 0}
                onChange={(i): void => {
                    setSatisfied(i === 1);
                }}
            />

            {/* NO REVIEW CONDITIONS EMPTY STATE */}
            {filteredConditions.length === 0 && (
                <div className="mt-16">
                    <EmptyStateNew
                        actionButtonType="secondary"
                        title={`No ${satisfied ? 'satisfied' : 'outstanding'} review conditions`}
                        icon={<ClipboardDocumentCheckIcon />}
                        titleSize="small"
                        helpText={`${satisfied ? 'Satisfied' : 'Outstanding'} review conditions will show here.`}
                        helpLink="https://learn.cimplico.com/docs/worksheet-review-conditions"
                    />
                </div>
            )}

            {/* REVIEW CONDITIONS LIST */}
            {filteredConditions.length > 0 && (
                <ul className="flex-col-reverse flex gap-4">
                    {filteredConditions.map((condition, idx) => {
                        return (
                            <li key={idx}>
                                <ReviewCondition condition={condition} />
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
}

export default ReviewConditionsList;
